import Steps from './Steps';


Steps.install = function(Vue) {
  Vue.component(Steps.name, Steps);
};

export default Steps;
